<template>
  <div class="vcard">
    <div class="type-1 flex-center">
      <div>
        <img class="avatar" :src="avatar" />
      </div>
      <div style="padding-left: 12px;">
        <div class="t-name flex-center">
          <span class="van-ellipsis name-left">{{ name }}</span>
          <span>{{ position }}</span>
          <img
            src="https://img.esenyun.com/images/20200813/6c150633d2874b18a09d165f3aef3c38.png"
            style="width: 12px;height: 12px;margin-left :2px;"
          />
        </div>
        <div class="t-sub">联系服务顾问，了解更多</div>
      </div>
      <div
        class="flex-center"
        style="flex: 1;justify-content:flex-end;margin-right: 20px;"
      >
        <div class="opt-icon flex-center" @click="makePhone">
          <img
            src="https://img.esenyun.com/images/20200602/542b83e4257c4030acb64662b7a6de41.png"
          />
        </div>
      </div>
      <div class="opt-icon flex-center" @click="clickshowVcard">
        <img
          src="https://img.esenyun.com/images/20200602/0a45d8d030f84ff2b7274ac7fb8db648.png"
        />
      </div>
    </div>
    <div v-if="posterData&&showVcard">
    <VCardNew
          :posterData="posterData"
          :eacrdImg="eacrdImg"
          @showMark="showMark(false)"
          @imgOK="onImgOK"
    ></VCardNew>
    <div class="showimg flex-column" style="margin-bottom:20px" v-if="show" @click="hide($event)">
    <div style="text-align:right;margin-bottom:20px">
      <img @click="hide($event)" class="img" src="../assets/x.svg" />
    </div>
    <div class="img"><img class="vard-img" :src="img" /></div>
    <div class="tips">长按名片图片保存到手机/分享</div>
  </div>
  </div>
  </div>
</template>

<script>
import VCardNew from "@/components/VCardNew"
export default {
  props: ['posterData', 'disabled', 'posterImg'],
  components: {
    VCardNew,
  },
  data() {
    return {
      showVcard: false,
      avatar: '',
      name: '',
      position: '',
      company: '',
      mobile: '',
      eacrdImg:"",
      show:false
    }
  },
  watch: {
    posterData: {
      handler(value) {
        if (value) {
          this.avatar = value.avatar
          this.name = value.name
          this.position = value.position
          this.company = value.company || 'A.O.史密斯'
          this.mobile = value.mobile
          this.qrCode = value.qrCode
        }
        console.log(2233, value)
      },
      immediate: true,
    }
  },
  mounted() {
  },
  methods: {
    showMark(e) {
      this.showVcard = e
      this.$emit('open', e)
      this.$emit('showMark',false)
    },
    // 打电话
    makePhone() {
      window.location.href = `tel:${this.mobile}`
    },
    saveImg() {
      this.$share.saveImgTOPhoto(this.posterImg)
      this.showVcard = false
      this.$emit('open', false)
    },
    hide(e){
      e.cancelBubble = true
      e.stopPropagation()
      this.show=false
      this.$emit('showMark',false)
    },
    // 海报生成成功
    onImgOK(img) {
      console.log('----------------------')
      this.eacrdImg=img
      this.$emit('ok', img)
    },
    clickshowVcard(){
      this.showVcard = true
      this.$emit('showMark',true)
    }
  },
}
</script>

<style lang="less" scoped>
.forward_text {
  padding: 24px 0 16px 0;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  .arrow {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 8px solid #7d7e80;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin: 0 6px;
  }
}
.show_vcard {
  height: 218px;
  margin-top: 56px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
  border-radius: 5px;
  .title {
    position: relative;
    height: 138px;
    background: url('https://img.esenyun.com/images/20200602/1da422ddd2e641f697d619590d9340dd.png')
      no-repeat;
    background-size: 100%;
    .logo {
      text-align: center;
      position: relative;
      height: 38px;
      top: -30%;
      .logo-container {
        width: 76px;
        height: 76px;
        display: inline-block;
        border-radius: 50%;
        // margin-top: -38px;
        border: 4px solid #fff;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .name {
    margin-top: 12px;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
  }
  .sub {
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    margin-top: 7px;
    text-align: center;
  }
  .phone {
    font-size: 20px;
    line-height: 24px;
    margin-left: 20px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  .opt-icon {
    width: 40px;
    height: 40px;
    justify-content: center;
    margin-right: 20px;
    text-align: center;
    border-radius: 50%;
    background: #ebf2ff;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.opt-icon {
  width: 40px;
  height: 40px;
  justify-content: center;
  text-align: center;
  border-radius: 50%;
  background: #ebf2ff;
  img {
    width: 20px;
    height: 20px;
  }
}
.type-1 {
  height: 64px;
  font-size: 14px;
  .avatar {
    border: 1px solid #dcdde0;
    width: 46px;
    height: 46px;
    border-radius: 50%;
  }
  .t-name {
    line-height: 22px;
    .name-left {
      max-width: 100rpx;
      margin-right: 4px;
    }
  }
  .t-sub {
    font-size: 12px;
    line-height: 20px;
    color: #7d7e80;
  }
}
.showimg{
  position:fixed;
  left: 0px;
  top:0px;
  height:100%;
  width: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.8);
  padding:20px;
  .img{
    flex-grow: 1;
    text-align: center;
    img{
       width: 90%;
    }
  }
  .tips{
    flex-grow: 0;
    flex-shrink: 0;
    text-align: center;
    line-height:120px;
    font-size:1.1rem;
    color:#fff;
  }
  .btns{
    flex-grow: 0;
    width: 100%;
    text-align: center;
    justify-content:center;
    .btny{
      display:inline-block;
      border: none;
      background: #F9E14C;
      border-radius: 50px;
      font-size: 16px;
      color: #323233;
      width: 55%;
    }
    .btnb{
      display:inline-block;
      border: none;
      background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);
      border-radius: 50px;
      font-size: 16px;
      color: #FFFFFF;
      width: 55%;
    }
  }
}
</style>
